<template>
  <div>
    <el-col :span="24" class="nav">
      <div class="navCss">
        <ul class="nav_inner">
          <li class="firstMenu active">
            <a href="javascript:;" @click="goIndex">网站首页</a>
          </li>
          <li
            v-for="(nav,index) in navList"
            :key="index"
            style="position: relative;"
            class="firstMenu"
          >
            <template v-if="index < 9">
              <template v-if="nav.level2.length == 0">
                <div>
                  <router-link
                    :to="{path:'/leftNavList',query: {fId:nav.catid, id:nav.catid, name:nav.catname}}"
                    tag="a"
                  >{{nav.catname}}</router-link>
                </div>
              </template>
              <template v-if="nav.level2.length > 0">
                <router-link
                  :to="{path:'/list',query: {fId:nav.catid, id:nav.catid, name:nav.catname}}"
                  tag="a"
                >{{nav.catname}}</router-link>
                <ul class="submenu_ul">
                  <li v-for="(subnav,i) in nav.level2" :key="i" class="submenu" :data-id="i">
                    <template v-if="nav.catid == 1 && subnav.catid == 14">
                      <router-link
                        :to="{path:'/list',query: {fId:nav.catid, id:subnav.catid, name:nav.catname, secondName:subnav.catname}}"
                        tag="a"
                      >{{subnav.catname}}</router-link>
                    </template>
                    <template v-else>
                      <router-link
                        :to="{path:'/leftNavList',query: {fId:nav.catid, id:subnav.catid, name:nav.catname, secondName:subnav.catname}}"
                        tag="a"
                      >{{subnav.catname}}</router-link>
                    </template>
                  </li>
                </ul>
              </template>
            </template>
          </li>
        </ul>
      </div>
    </el-col>
  </div>
</template>
<script>
var that;
export default {
  data() {
    return {
      navList: []
    };
  },
  mounted() {
    that = this;
    that.init();
  },
  methods: {
    goIndex() {
      sessionStorage.setItem("scrollHei", 0);
      that.$router.push({ path: "/" });
    },
    init() {
      $.ajax({
        type: "get",
        url: url + "/category",
        success: function(data) {
          if (data.code == "0") {
            that.navList = data.data;
          }
        },
        error(data) {
          alert(data.msg);
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      //复用组件时，想对路由参数的变化作出响应的话，你可以简单地 watch (监测变化) $route 对象：
      that.init();
    }
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/com/nav.vue